import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';

export interface LoanOption {
  loanAmount: number;
  interestRate: number;
  tenure: number;
  totalAmount: number;
  tenurePeriod: string;
}

export interface SaccoDetails {
  name: string;
  memberName: string;
  memberId: string;
  referenceId?: string;
  logo?: string;
  address?: string;
  phone?: string;
  email?: string;
  mobileMoneyNumber: string;
  operator: string;
}

export interface CoreResponse {
  success: boolean;
  message: string;
  data?: any;
}

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  private baseUrl = environment.apiUrl.coreUrl || 'https://api.example.com';

  constructor(private http: HttpClient) {}

  /**
   * Get loan offer details based on token and ID
   */
  getLoanOffer(token: string): Observable<any> {
    return this.makeAuthenticatedRequest('GET', `/public/end-user-offers`, token);
  }


  /**
   * Generate OTP for loan request
   * POST /otp/generate with requestId
   */
  generateOTP(token: string): Observable<any> {
    return this.makeAuthenticatedRequest('POST', `/public/otp/generate`, token, {});
  }

  /**
   * Resend OTP for loan request
   * POST /resend with requestId
   */
  resendOTP(token: string): Observable<any> {
    return this.makeAuthenticatedRequest('POST', `/public/otp/resend`, token, {});
  }

  /**
   * Submit OTP for loan request approval
   * PATCH /requests/:id with status and otp
   */
  submitOTP(token: string, otp: string, loanOfferAmount: number, isLegacy: boolean): Observable<any> {
    return this.makeAuthenticatedRequest('POST', `/public/end-user-offers`, token, {
      otp: otp,
      loanOfferAmount,
      isLegacy
    }); 
  }

  /**
   * Generic method to make authenticated API calls with token
   */
  private makeAuthenticatedRequest<T>(
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
    endpoint: string,
    token: string,
    body?: any,
    params?: HttpParams
  ): Observable<T> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    const options = {
      headers,
      params,
    };

    switch (method) {
      case 'GET':
        return this.http.get<T>(`${this.baseUrl}${endpoint}`, options);
      case 'POST':
        return this.http.post<T>(`${this.baseUrl}${endpoint}`, body, options);
      case 'PUT':
        return this.http.put<T>(`${this.baseUrl}${endpoint}`, body, options);
      case 'DELETE':
        return this.http.delete<T>(`${this.baseUrl}${endpoint}`, options);
      case 'PATCH':
        return this.http.patch<T>(`${this.baseUrl}${endpoint}`, body, options);
      default:
        throw new Error(`Unsupported HTTP method: ${method}`);
    }
  }
}
